import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TimelineLite,Timeline,TimelineMax,TweenLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {ImmortalFruitsGameMode} from "../ImmortalFruitsGameMode";
import {IImortalFruitsParsedServerData} from "../server/data/IImortalFruitsParsedServerData";
import {BonusWheelView} from "../views/bonusWheelView";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ImmortalFruitsParsedInitData} from "../server/data/ImmortalFruitsParsedInitData";
import {bonusWheelEvents} from "./bonusWheelController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";


export class ImmortalFruitsStoppablePresentation implements GameRoundPresentation {
    private _tl: TimelineLite;
    private _hitPos: number=0;
    private _nextMode: string=ImmortalFruitsGameMode.NORMAL;
    private hidewheel :boolean =false;
    private _view: BonusWheelView;
    private _isAborted: boolean = false;
    private nextMode: string;
    private isWin: boolean =false;
    private _scatterPositions:number[];
    private wheelOneValues:number[];
    private _velocityTl: TimelineLite;
    private allWheels: BonusWheelView[] = [];
    private isAborted:boolean = false;

    constructor() {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));

        this._velocityTl = new TimelineLite();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, bonusWheelEvents.NOTIFY_FINISH, (event: GameEvent) => this.getNotificationOfTimeLineFinish(event.params[0]));

        let wheel: BonusWheelView = new BonusWheelView(0);
        this.allWheels.push(wheel);
        this._view = this.allWheels[0];
    }
    private onGameDataParsed(data:ImmortalFruitsParsedGameData){
        this._view.onGameDataParsed(data!);
    }
    private onInitDataParsed(data: ImmortalFruitsParsedInitData): void {
        this._view.scatterPostion(data!);
        //this.setVelocity(0.05);
        this.nextMode = data.nextMode;
        this._isAborted = false;
    }
    /**
     * @inheritDoc
     * @param data
     */
    getAnimation(data: ImmortalFruitsParsedGameData): gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax | null {
       this._nextMode = data.nextMode;
       this.hidewheel =false;

        if(data.nextMode===ImmortalFruitsGameMode.BONUS_WHEEL || data.mode ===ImmortalFruitsGameMode.BONUS_WHEEL) {
            /*299*/
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STOPPED));
            this._tl = new TimelineLite({onComplete:()=>{
                    //console.log("endAnimation")
                    //EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.END_ANIMATION));
                }});
            this._tl.add(()=>{
                   //console.log("aftr 4 sec")
            },3);
            this._tl.add(()=>{
                if(this._scatterPositions){
                    this._view.startSpinning();
                    //this.setVelocity(accSpeed);
                    //console.log("startPresentation")
                }

            },0);
            return this._tl;
        }
        return null;
    }
    private getNotificationOfTimeLineFinish(timlineDuration:number){
        if(!this.isAborted){
            //console.log("increased Timline")
            this._tl.add(()=>{
            },timlineDuration+1);
        }else{
            //console.log("skipped increasing Timline")
        }

        //this._mainTLDuration = timlineDuration;

    }

    public prepare(data: IImortalFruitsParsedServerData): void {
        if(data.wheelLevel==1){
            this.wheelOneValues = data.wheelOneValues;
        }else if(data.wheelLevel==2){
            this.wheelOneValues = data.wheelTwoValues;
        }else{
            this.wheelOneValues = data.wheelThreeValues;
        }

        this._scatterPositions = data.scatterPositions!;
        this.isWin = data.nextMode=== ImmortalFruitsGameMode.BONUS_WHEEL;
        this._view.resetCallbackCount(0);
        this._hitPos = data.landedWheelIndex;
    }
    abort(isActive: boolean, data: ParsedServerData): Timeline | null {

        if(this._tl && this._tl.totalProgress()<1){
            this._tl.totalProgress(1);
            this._tl.clear();
        }
        //console.log("abortedSPIN");
        EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.ABORT_SPINNING));
        let tl = new TimelineLite();
        return tl
    }
}